/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Portafogli { 
    residuo?: number;
    costo_pasto?: number;
    saldo_iniziale?: number;
    pasti_usufruiti?: number;
}

